export const memoizeLast = func => {
  let lastArgs;
  let lastResult;
  let called = false;
  const equalToLast = (newArg, index) => newArg === lastArgs[index];
  return (...args) => {
    if (called && lastArgs.length === args.length && args.every(equalToLast)) {
      return lastResult;
    }
    called = true;
    lastArgs = args;
    lastResult = func(...args);
    return lastResult;
  };
};